import React from 'react';
import {connect} from "react-redux";
import Select from "react-select";
import * as utils from "../../../utils/currency";
import l10n from "../../../l10n/localization";

class SelectCurrencies extends React.Component {
    constructor(props) {
        super(props);
        this.state = {...props.formData};
    }

    onChange(value) {
        this.props.onChange(value);
    }

    render() {


        return (
            <div className="form-group field">
                <label className="control-label" htmlFor="root_currency">
                    {l10n.common.currency}
                </label>

                <Select
                    backspaceRemoves={false}
                    className="form-control"
                    name="root_currency"
                    value={this.props.formData}
                    options={utils.currencyToSelect(this.props.currencies)}
                    isLoading={this.props.loading}
                    clearable={false}
                    onChange={this.onChange.bind(this)}
                    simpleValue
                    valueComponent={(props) => {
                        return (
                            <div className="Select-value" title={props.value.title}>
                                <span className="Select-value-label">
                                    {props.children}
                                </span>
                            </div>
                        )
                    }}
                />
            </div>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        currencies: state.currency.currencies,
        loading: state.currency.loading
    });
})(SelectCurrencies);


// WEBPACK FOOTER //
// ./src/components/forms/fields/SelectCurrencies.js